/** @deprecated Please don't use this.  Use `request` from `ui-utils` instead */
export var API_ROOT = window.API_ROOT || '';